import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Styles/Styles.css";
import { Button, Image } from "react-bootstrap";

const CustomButton = ({ style, className, onClick, icon, iconClassName, flag, text }) => {
	return (
		<div style={style}>
			<Button className={className} onClick={onClick}>
				{icon && <FontAwesomeIcon className={iconClassName} icon={icon} />}
				{flag && (
					<Image
						className={iconClassName}
						height={20}
						width={20}
						src={flag}
						alt="Flag"
					/>
				)}
				{text}
			</Button>
		</div>
	);
};

export default CustomButton;
